"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponUpdateSchema = exports.CouponUpdateScalarSchema = exports.CouponCreateSchema = exports.CouponCreateScalarSchema = exports.CouponPrismaUpdateSchema = exports.CouponPrismaCreateSchema = exports.CouponSchema = exports.CouponScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    attachedDiscount: zod_1.z.number(),
    validUntil: zod_1.z.coerce.date(),
    redeemed: zod_1.z.boolean().default(false),
    descriptionEN: zod_1.z.string(),
    descriptionFR: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
}).strict();
const relationSchema = zod_1.z.object({
    order: zod_1.z.record(zod_1.z.unknown()),
    merchant: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    orderId: zod_1.z.string().uuid(),
    merchantId: zod_1.z.string().uuid(),
});
/**
 * `Coupon` schema excluding foreign keys and relations.
 */
exports.CouponScalarSchema = baseSchema;
/**
 * `Coupon` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.CouponSchema = exports.CouponScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.CouponPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.CouponPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    attachedDiscount: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    validUntil: zod_1.z.coerce.date(),
    redeemed: zod_1.z.boolean().default(false),
    descriptionEN: zod_1.z.string(),
    descriptionFR: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date())
}).partial().passthrough();
/**
 * `Coupon` schema for create operations excluding foreign keys and relations.
 */
exports.CouponCreateScalarSchema = baseSchema.partial({
    redeemed: true, createdAt: true, updatedAt: true
});
/**
 * `Coupon` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.CouponCreateSchema = exports.CouponCreateScalarSchema.merge(fkSchema);
/**
 * `Coupon` schema for update operations excluding foreign keys and relations.
 */
exports.CouponUpdateScalarSchema = baseSchema.partial();
/**
 * `Coupon` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.CouponUpdateSchema = exports.CouponUpdateScalarSchema.merge(fkSchema.partial());
